import { Alert } from 'components/v2/Alert/Alert';
import { Button } from 'components/v2/Buttons/Button/Button';
import styled from 'styled-components';

export const Container = styled.section`
  position: relative;
  margin: 24px 16px;

  @media ${({ theme }) => theme.queries.minDesktop} {
    margin: 24px 0;
  }
`;

export const Announcement = styled(Alert)`
  padding-right: 64px;
`;

export const DismissButton = styled(Button)`
  position: absolute;
  top: 8px;
  right: 8px;
`;
